module.exports = __webpack_public_path__ + "static/shoes-ad5bc3d4b1aa9bafe2b9d53c6537d4d2.png";